import React, { useCallback, useState } from 'react';
import * as Styles from './ReloadRebuildVpsOci.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale/useLocale';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';

export const ReloadRebuildVpsOci = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const {
    reloadRebuildVpsOci: reloadRebuildLocale,
  } = ticketsLocale.forms;
  const [formData, setFormData] = useState({
    agreedRebuildReloadTerms: false,
    agreedResponsability: false,
  });

  const checkForm = useCallback(() => !(
    !!formData.agreedRebuildReloadTerms
      && !!formData.agreedResponsability
  ), [formData]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: reloadRebuildLocale.subject,
      server_value: selectedProduct.serverhostname,
      domain_value: selectedProduct.domain,
      key: V2Forms.RELOAD_REBUILD_VPS_OCI,
      tags: [
        'whmcs_form_tecnico_rebuild_oci',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
        • ${reloadRebuildLocale.body.product(selectedProduct)}
        • ${reloadRebuildLocale.body.request}
        • ${reloadRebuildLocale.body.agreedRebuildReloadTerms(formData.agreedRebuildReloadTerms)}
        • ${reloadRebuildLocale.body.agreedResponsability(formData.agreedResponsability)}
        • ${reloadRebuildLocale.body.productId(selectedProduct)}
      `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    selectedProduct,
    formData,
    submitForm,
    reloadRebuildLocale,
  ]);

  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {reloadRebuildLocale.info}
      </Styles.Info>

      <Styles.InputsWrapper>

        <Styles.CheckboxLabel
          htmlFor="#readTermsagreedRebuildReloadTerms"
          data-testid="agreedRebuildReloadTerms"
          onClick={() => handleChange({ key: 'agreedRebuildReloadTerms', value: !formData.agreedRebuildReloadTerms })}
        >
          <Checkbox checked={formData.agreedRebuildReloadTerms} id="readTermsagreedRebuildReloadTerms" />
          <Styles.Text>
            {reloadRebuildLocale.placeholders.agreedRebuildReloadTerms}
          </Styles.Text>
        </Styles.CheckboxLabel>

        <Styles.CheckboxLabel
          htmlFor="#readTermsagreedResponsability"
          data-testid="agreedResponsability"
          onClick={() => handleChange({ key: 'agreedResponsability', value: !formData.agreedResponsability })}
        >
          <Checkbox checked={formData.agreedResponsability} id="readTermsagreedResponsability" />
          <Styles.Text>
            {reloadRebuildLocale.placeholders.agreedResponsability}
          </Styles.Text>
        </Styles.CheckboxLabel>

      </Styles.InputsWrapper>


      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : reloadRebuildLocale.confirmCancel}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default ReloadRebuildVpsOci;
